<div class="modal-header">
  <h4 class="modal-title">Update Member</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <form (ngSubmit)="form.valid && onSubmit()" autocomplete="off" #form="ngForm" class="container">
    <div class="alert alert-warning" role="alert">
      <i class="fas fa-exclamation-triangle me-2"></i>
      <strong>Important:</strong> Please confirm with Data Engineering before updating a member's First Name, Last Name,
      or DOB.
    </div>

    <div class="form-group form-row required">
      <label for="firstName" class="col-md-4 col-sm-12 col-form-label">First Name</label>
      <div class="col-md-8 col-sm-12">
        <input
          [(ngModel)]="patient.firstName"
          type="text"
          class="form-control"
          name="firstName"
          id="firstName"
          maxlength="60"
          #firstName="ngModel"
          required
        />
        @if (form.submitted && firstName.invalid) {
          <div class="invalid-feedback">Please provide a first name</div>
        }
      </div>
    </div>

    <div class="form-group form-row required">
      <label for="lastName" class="col-md-4 col-sm-12 col-form-label">Last Name</label>
      <div class="col-md-8 col-sm-12">
        <input
          [(ngModel)]="patient.lastName"
          type="text"
          class="form-control"
          name="lastName"
          id="lastName"
          maxlength="100"
          #lastName="ngModel"
          required
        />
        @if (form.submitted && lastName.invalid) {
          <div class="invalid-feedback">Please provide a last name</div>
        }
      </div>
    </div>

    <div class="form-group form-row required">
      <label for="dob" class="col-md-4 col-sm-12 col-form-label">DOB</label>
      <div class="col-md-8 col-sm-12">
        <th-datetime-picker
          required
          name="dob"
          [utc]="true"
          [(ngModel)]="patient.dob"
          #dob="ngModel"
        ></th-datetime-picker>
        @if (form.submitted && dob?.invalid) {
          <div class="invalid-feedback">
            @if (dob?.errors?.required) {
              <div>Please provide a date of birth</div>
            }
            @if (dob?.errors?.validDate) {
              <div>{{ dob?.errors?.validDate }}</div>
            }
            @if (dob?.errors?.minDate) {
              <div>{{ dob?.errors?.minDate }}</div>
            }
            @if (dob?.errors?.maxDate) {
              <div>{{ dob?.errors?.maxDate }}</div>
            }
          </div>
        }
      </div>
    </div>

    <div class="form-group form-row required">
      <label for="medicalHome" class="col-md-4 col-sm-12 col-form-label">Medical Home</label>
      <div class="col-md-8 col-sm-12">
        <select
          name="medicalHome"
          id="medicalHome"
          class="form-select"
          [class.loading]="loadingMedicalHomes"
          [(ngModel)]="patient.medicalHome"
          #medicalHome="ngModel"
          [disabled]="loadingMedicalHomes"
          required
        >
          <option [ngValue]="null" disabled>Please select...</option>
          @for (medicalHome of medicalHomes; track medicalHome) {
            <option [ngValue]="medicalHome.providerGroupID">
              {{ medicalHome.description }}
            </option>
          }
        </select>
        @if (form.submitted && medicalHome.invalid) {
          <div class="invalid-feedback">Please select a medical home</div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button
        id="updateManualPatientInfoSubmit"
        type="submit"
        class="btn btn-primary"
        [thLoadingIndicator]="{
          loading: submitting,
          disabled: loadingMedicalHomes
        }"
      >
        Update Member
      </button>
      <button id="updateManualPatientInfoCancel" type="button" class="btn btn-outline-primary" (click)="closeModal()">
        Cancel
      </button>
    </div>
  </form>
</div>
